import { useRef } from "react";

import { type Layer, type LayerProps,ribbon, rowX, setPath, smoothstep, Strand, toPath, usePainter } from "./core";

/** Where the two strands split apart. */
const PIVOT = 250;
const RISE = 150;

/** EBITDA +20k€: earnings rise, the mirrored cost strand falls, the gap is profit. */
export const Ebitda: Layer = Object.assign(
  ({ register }: LayerProps) => {
    const band = useRef<SVGPathElement>(null);
    const cost = useRef<SVGPathElement>(null);

    usePainter(register, () => (pts, a) => {
      const falling = pts.map((p) => ({ x: p.x, y: 2 * PIVOT - p.y }));
      setPath(cost.current, toPath(falling), 0.4 * a);
      setPath(band.current, ribbon(pts, falling), 0.12 * a);
    });

    return (
      <>
        <path ref={band} fill="currentColor" stroke="none" opacity={0} />
        <Strand ref={cost} />
      </>
    );
  },
  {
    shape: (u: number) => ({ x: rowX(u), y: PIVOT - smoothstep(u) * RISE }),
  },
);
